import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpModule, RequestOptions } from '@angular/http';
import { EventBaseService } from './meta/event-bases/event-base.service';
import { PriceMatrixService } from './pricing/price-matrix.service';
import { AzcMomentPipe } from './common/datetime/azc-moment.pipe';
import { FollowUpDatePipe } from './common/datetime/follow-up-date.pipe';
import { RequestOptionsService } from './common/request-options.service';
import { ConciergeService } from './concierges/concierge.service';
import { CustomerCardService } from './customers/cards/customer-card.service';
import { CustomerService } from './customers/customer.service';
import { CustomerNoteService } from './customers/notes/customer-note.service';
import { PaymentHistoryService } from './customers/payment-history/payment-history.service';
import { EventQuestionService } from './discovery/event-questions/event-question.service';
import { EventTemplateService } from './discovery/event-templates/event-template.service';
import { RecommendationService } from './discovery/recommendations/recommendation.service';
import { ActivityService } from './events/activities/activity.service';
import { EventCustomerService } from './events/customers/event-customer.service';
import { EventInvitationService } from './events/customers/invitations/event-invitation.service';
import { EventMessagingService } from './events/customers/messaging/event-messaging.service';
import { EventService } from './events/event.service';
import { EventNoteService } from './events/notes/event-note.service';
import { EventPaymentService } from './events/payments/event-payment.service';
import { MetaService } from './meta/meta.service';
import { ProductService } from './products/product.service';
import { ProviderDealService } from './providers/deals/provider-deal.service';
import { ProviderNoteService } from './providers/notes/provider-note.service';
import { ProviderService } from './providers/provider.service';
import { AutoSearchService } from './search/auto/auto-search.service';
import { AuthGuard } from './users/auth-guard.service';
import { AuthService } from './users/auth.service';
import { REQUIRE_ROLE_AUTH, UserService } from './users/user.service';
import { EventTypeService } from './meta/event-type.service';
import { ExperienceService } from './discovery/experiences/experience.service';

@NgModule({
	imports: [
		CommonModule,
		HttpModule,
		HttpClientModule
	],
	declarations: [AzcMomentPipe, FollowUpDatePipe],
	exports: [AzcMomentPipe, FollowUpDatePipe],
	providers: [
		{ provide: RequestOptions, useClass: RequestOptionsService },
		AuthGuard,
		MetaService,
		EventTypeService,
		EventBaseService,
		PriceMatrixService,
		CustomerService,
		CustomerCardService,
		CustomerNoteService,
		PaymentHistoryService,
		EventService,
		EventNoteService,
		EventCustomerService,
		EventInvitationService,
		EventMessagingService,
		EventPaymentService,
		EventTemplateService,
		EventQuestionService,
		ActivityService,
		ProviderService,
		ProviderNoteService,
		ProductService,
		ConciergeService,
		UserService,
		RecommendationService,
		ProviderDealService,
		AutoSearchService,
		ExperienceService
	]
})
export class AzcCoreModule {
	public static forRoot(requireRoleAuth?: boolean): ModuleWithProviders {
		return {
			ngModule: AzcCoreModule,
			providers: [
				AuthService,
				{ provide: REQUIRE_ROLE_AUTH, useValue: requireRoleAuth }
			]
		};
	}
}
